import '@accessible360/accessible-slick';
export const Slideshow = (() => {
	'use strict';

	function init() {
		var myCarousel = $(".slideshow:not(.slick-initialized)");
		myCarousel.each(function() {
			$(this).slick({
				infinite: true,
				dots: false,
				arrows: false,
				speed: 12000,
				cssEase: 'linear',
				autoplay: true,
				autoplaySpeed: 0,
				slide: 'div',
				focusOnSelect: true,
				pauseOnHover: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '160px',
				variableWidth: true,

				responsive: [
					{
						breakpoint: 1024,
						settings: {
							centerPadding: '40px',
						}

					}
				]
			});
		});
	}

	return {
		init: init,
		name: 'slideshow'
	};
})();
